<template>
  <LayoutMinimal>
    <div
      id="login_or_register"
    >
      <template v-if="$auth.ready()">
        <section class="main">
          <div class="login-or-register-box">
            <div class="form">
              <h1 class="title">
                {{$t('login.title')}}
              </h1>
              <h4 class="payment_redirect_msg" v-if="paymentToRedirectTo">
                {{$t('login.payment_redirect_msg')}}
              </h4>
              <LoginForm
                @successfullLogin="successfullAuthHandler"
              />
              <!-- Por el momento solo login, si no tiene cuenta lo mandamos a comprar, de acuerdo a lo solicitado por Alvaro -->
              <!--<RegisterForm
                    @successfullRegister="successfullAuthHandler"
              />-->
              <router-link
                class="no-account"
                :to="{name: 'singup'}"
              >
                <h2 class="singup">
                  {{$t('login.singup')}}
                </h2>
              </router-link>
            </div>
            <div class="change-mode">
              <div class="content">
                <div v-if="modeLogin">
                  <h1 class="title">
                    {{$t('login.requires_registration.title')}}
                  </h1>
                  <h4 class="subtitle">
                    {{$t('login.requires_registration.subtitle')}}
                  </h4>
                  <router-link
                    :to="{name: 'subscribe'}"
                  >
                    <h2 class="get-access-here">
                      {{$t('footer.get_access')}}
                    </h2>
                  </router-link>
                  <router-link
                    :to="{name: 'webstars.index'}"
                  >
                    <div class="footer">
                      {{$t('login.requires_registration.footer')}}
                    </div>
                  </router-link>
                </div>
                <div v-else>
                  <h1 class="title">
                    {{$t('register.requires_login.title')}}
                  </h1>
                  <h4 class="subtitle">
                    {{$t('register.requires_login.subtitle')}}
                  </h4>
                  <router-link
                    :to="{name: 'subscribe'}"
                  >
                    <h2 class="get-access-here">
                      {{$t('footer.get_access')}}
                    </h2>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </template>
    </div>
    <template slot="after">
      <!--      <Footer/>-->
    </template>
  </LayoutMinimal>
</template>

<script>
    import LoginForm from '../components/LoginForm';
    import RegisterForm from '../components/RegisterForm';
    import Footer from '../components/Footer';
    import LayoutMinimal from '../layouts/LayoutMinimal';

    export default {
      components: {
          LoginForm,
          RegisterForm,
          Footer,
          LayoutMinimal,
      },
      data(){
        return {
          user: null,
          modeLogin: true, //!parseInt(this.$route.query.r),
        }
      },
      methods: {
        successfullAuthHandler(){
          if(this.paymentToRedirectTo){
            this.$router.push({name: 'payment.result', query: {id: this.paymentToRedirectTo}});
          }else{
            // si estoy siguiendo a una webstar pero no tenía membrecia, me mandaba a suscribirme
            // => que me envie siempre al home
            this.$router.push({name: 'home'});

            // if(this.$auth.user().membership_active){
            //   this.$router.push({name: 'home'});
            // }else{
            //   this.$router.push({name: 'subscribe'});
            // }
          }
        },
        /*changeMode(){
            this.$router.replace({name: 'login', query: {r: this.modeLogin ? 1 : 0}});
        }*/
      },
      computed: {
        paymentToRedirectTo(){
          return this.$route.query.payment_id;
        }
      },
      beforeRouteUpdate (to, from, next) {
          //this.modeLogin = !parseInt(to.query.r);

          next();
      },
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #login_or_register{
    background-color: $pallete_dark_color;
    display: flex;
    color: $pallete_clear_text_color;
    flex-direction: column;
    justify-content: center;
    max-width: 750px;

    section.main {
      justify-content: space-around;
      position: relative;
      margin: 0;

      .login-or-register-box{
        display: flex;
        margin: 0 auto;
        padding: 1.5em;
        background-color: #e6e6e6;
        border-radius: 10px;
        background: linear-gradient(to bottom,#e6e6e6 0,#ccc 100%);
        margin-left: 1em;
        margin-right: 1em;

        @media(max-width: 450px){
          border-radius: 0;
          margin-left: 0;
          margin-right: 0;
          padding: .5em;
          width: 100vw;
        }

        .form{
          min-width: 350px;
          padding: 1em;
          background-color: #000000;
          border-radius: 5px;
          margin-right: 1.5em;

          .title{
            text-align: center;
            width: 100%;
            text-transform: uppercase;
            letter-spacing: 0;
            margin: 0 0 .5em 0;
          }

          .payment_redirect_msg{
            text-align: center;
          }
  
          .no-account{
            display: block;
            text-align: center;
            
            .singup{
              @extend %fresh-btn;
    
              text-align: center;
              background-color: $pallete_main_color;
              width: auto;
              display: inline-block;
              padding: .25em;
              text-transform: uppercase;
              color: #ffffff;
              font-size: 30px;
              letter-spacing: 2px;
              border-color: darken($pallete_main_color, 5%);
    
              &:hover{
                border-color: darken($pallete_main_color, 25%);
                background-color: lighten($pallete_main_color, 5%);
              }
            }
          }

          @media(max-width: 500px){
            min-width: auto;
          }
        }

        .change-mode {
          border-left: 10px solid $pallete_main_color;
          border-radius: 5px;
          background-image: url('/img/login-background.png');
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          //cursor: pointer;
          user-select: none;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-basis: 50%;
          color: #ffffff;
          text-align: center;
          padding: 2.5em 1em;
          margin-bottom: 0;

          .title{
            text-transform: uppercase;
          }

          .subtitle{
            text-transform: uppercase;
          }

          .get-access-here{
            @extend %fresh-btn;

            margin: 0;
            background-color: $pallete_main_color;
            width: auto;
            display: inline-block;
            padding: .25em;
            text-transform: uppercase;
            color: #ffffff;
            font-size: 30px;
            letter-spacing: 2px;
            border-color: darken($pallete_main_color, 5%);

            &:hover{
              border-color: darken($pallete_main_color, 25%);
              background-color: lighten($pallete_main_color, 5%);
            }
          }
            
            
            
            .footer{
              text-transform: uppercase;
              font-size: .9em;
              font-weight: bold;
              margin-top: 30px;
              text-shadow: 1px 1px #000;
            }
            
            
        }

        @media(max-width: 800px) {
          flex-direction: column;

          .form{
            margin-right: 0;
            margin-bottom: 1.5em;
          }

          .change-mode {
            border-left: none;
            border-top: 10px solid $pallete_main_color;
          }
        }
      }
    }
  }
</style>
